import { GeneralCommonsModule } from '@/src/app/shared/modules/general-commons/general-commons.module';
import { CommonModule, LowerCasePipe } from '@angular/common';
import { Component, EventEmitter, Input, NgModule, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatSortModule, Sort } from '@angular/material/sort';
import {
  MatTableDataSource,
  MatTableModule,
  MatTable,
  MatColumnDef,
  MatHeaderCellDef,
  MatHeaderCell,
  MatCellDef,
  MatCell,
  MatHeaderRowDef,
  MatHeaderRow,
  MatRowDef,
  MatRow
} from '@angular/material/table';
import { TranslateModule } from '@ngx-translate/core';
import { ReadonlyCommonsModule } from '@shared/modules/readonly-commons/readonly-commons.module';
import { SimpleReportTableColumn } from '@src/app/features/reports/components/report-filters/models/report-data.model';
import { FormatNumberPipe } from '@shared/modules/readonly-commons/pipes/number/stx-number.pipe';

@Component({
  selector: 'stx-simple-report-table',
  templateUrl: './simple-report-table.component.html',
  imports: [
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    LowerCasePipe,
    FormatNumberPipe
  ]
})
export class SimpleReportTableComponent {
  @Input() columns: SimpleReportTableColumn[] = [];
  @Input() displayedColumns: string[] = [];
  @Input() dataSource: MatTableDataSource<unknown>;
  @Output() sortData: EventEmitter<Sort> = new EventEmitter<Sort>();

  get isMobileScreenSize(): boolean {
    const mobileBreakPointSize: number = 768;
    return window.innerWidth < mobileBreakPointSize;
  }
}

@NgModule({
  imports: [
    CommonModule,
    MatTableModule,
    MatSortModule,
    TranslateModule,
    MatIconModule,
    ReadonlyCommonsModule,
    GeneralCommonsModule,
    SimpleReportTableComponent
  ],
  exports: [SimpleReportTableComponent]
})
export class SimpleReportTableComponentModule {}
